(() => {
  let flag = 1;
  window.onLibReady = onLibReady;

  document.addEventListener('DOMContentLoaded', function () {
    const pathList = ['/pages/promo-code', '/pages/custom-waffle-maker', '/pages/dough-mixes-discount'];

    if (pathList.includes(location.pathname)) {
      init();
    } else {
      window.addEventListener('scroll', init, {passive: true});
      window.addEventListener('mousemove', init, {passive: true});
      window.addEventListener('touchstart', init, {passive: true});
    }
  });

  function init() {
    window.headScriptObserver.disconnect();

    if (flag) {
      flag = 0;

      window.removeEventListener('scroll', init);
      window.removeEventListener('mousemove', init);
      window.removeEventListener('touchstart', init);

      loadSections();
      loadVendors();
      lazyLoadImage();
      lazyLoadBgImage();
      lazyLoadIframe();
      loadAllJs();
    }
  }

  function lazyLoadImage() {
    document.querySelectorAll('[data-src]').forEach(function (elem) {
      elem.src = elem.dataset.src;
    });
  }

  function lazyLoadBgImage() {
    document.querySelectorAll('[data-bgsrc]').forEach(function (elem) {
      elem.style.backgroundImage = `url(${elem.dataset.bgsrc})`;
    });
  }

  function lazyLoadIframe() {
    document.querySelectorAll('iframe').forEach(function (elem) {
      elem.src = elem.dataset.src || elem.src;
    });
  }

  function loadAllJs() {
    setTimeout(function () {
      window.dispatchEvent(new Event('ez_load'));
      document.dispatchEvent(new Event('ez_load'));
    }, 100);

    const lazyScripts = document.getElementsByTagName('script');
    Array.from(lazyScripts).forEach(s => {
      if (s.type === 'lazyload.js') {
        const script = s.cloneNode(true);
        script.type = s.dataset.type ? s.dataset.type : 'text/javascript';

        if (s.src) {
          script.src = s.src;
          document.head.appendChild(script);
        } else if (s.innerHTML) {
          document.body.appendChild(script);
        }

        s.remove();
      }
    });
  }

  function loadVendors() {
    const scriptsToLoad = [
      {
        name: 'swiper',
        src: getShopifyLink('swiper.min.js'),
      },
      {
        name: 'vue',
        src: getShopifyLink('vue.min.js'),
      },
      {
        name: 'fancybox',
        src: getShopifyLink('fancybox.js'),
      },
      {
        name: 'body-scroll-lock',
        src: getShopifyLink('body-scroll-lock.js'),
      },
      {
        name: 'js-image-zoom',
        src: getShopifyLink('js-image-zoom.js'),
      },
    ];

    const tag = document.getElementsByTagName('script')[0];

    scriptsToLoad.forEach(s => {
      const script = document.createElement('script');
      script.type = 'text/javascript';
      script.async = true;
      script.src = s === null || s === void 0 ? void 0 : s.src;
      script.addEventListener('load', e => {
        window.Shopify.vendors = window.Shopify.vendors || [];
        window.Shopify.vendors.push(s.name);
        document.dispatchEvent(new CustomEvent(`${s.name}.loaded`));
      });

      return tag.parentNode.insertBefore(script, tag);
    });
  }

  // Waits for vendor libraries by listening for the `<name>.loaded` events
  // loadVendors already dispatches, rather than polling for them.
  //
  // This used to be a setInterval(100) that cleared itself once every library
  // was in window.Shopify.vendors. But the vendors are only fetched by
  // loadVendors, which runs from init - on the first scroll, mousemove or
  // touchstart. A visitor who reads the page without touching it never gets
  // them, so the condition never became true and the timer was never cleared:
  // one live timer per call, and 19 call sites across the theme. It also meant
  // the main thread never went idle, which is exactly what Time to Interactive
  // and Speed Index measure.
  //
  // The behaviour is unchanged - the callback still runs when, and only when,
  // every library is there - but nothing ticks while we wait.
  function onLibReady(libs, callback) {
    // Optional chaining on Shopify too: the check is synchronous now, so a
    // throw here would surface in the caller's connectedCallback rather than
    // in a timer tick.
    const isLoaded = lib => window.Shopify?.vendors?.includes(lib);
    const run = () => typeof callback === 'function' && callback();
    const pending = new Set(libs.filter(lib => !isLoaded(lib)));

    if (pending.size === 0) {
      run();
      return;
    }

    pending.forEach(lib => {
      const event = `${lib}.loaded`;

      const onLoaded = () => {
        document.removeEventListener(event, onLoaded);
        pending.delete(lib);

        if (pending.size === 0) {
          run();
        }
      };

      document.addEventListener(event, onLoaded);
    });
  }

  function loadSections() {
    const sectionList = document.querySelectorAll('[data-section-postload]');
    sectionList.forEach(section => {
      const breakpoint = section.dataset.sectionBreakpoint;

      if (window.innerWidth >= breakpoint || !breakpoint) {
        fetchSection(section);
      }
    });
  }

  function fetchSection(section) {
    let url = `/?view=sections&section_id=${section.dataset.sectionId}`;

    if (['collection', 'product'].includes(Shopify.template)) {
      url = `${location.pathname}?view=sections&section_id=${section.dataset.sectionId}`;
    }

    fetch(url)
      .then(response => response.text())
      .then(text => {
        section.innerHTML = text;
      });
  }
})();
